<app-modal title="Set {{ field?.replace('_', ' ')|capitalize }}" size="small" (save)="saveObject()" #field_modal>
    <input type="text" class="form-control" [(ngModel)]="new_value">
</app-modal>